export const SCREEN_NAME = 'ALARM_SETTING';
